import React, { FC, useContext } from 'react'
import { Container } from '../components'
import { FinalCard } from '../components/FinalCard.component'
import { GuestContext } from '../Guest.context'
import { Button, BUTTON_SIZE } from 'parkdepot-shared/components/Buttons'
import { useHistory } from 'react-router-dom'
import { ButtonContainer } from './GuestFinal.style'
import { useTranslation } from 'react-i18next'
import { ValidUntil } from '../components/ValidUntil.component'

export const Success: FC = () => {
    const { formData, endDateFormatted } = useContext(GuestContext)
    const history = useHistory()
    const { t } = useTranslation()

    return (
        <Container>
            <FinalCard
                title={t('guest.lpUnlocked')}
                description={<ValidUntil tKey={'guest.lpUnlockedDescription'} endDate={endDateFormatted || ''} />}
                plate={formData?.plate || ''}
                country={formData?.country}
                result="success"
            />
            <ButtonContainer>
                <Button
                    $size={BUTTON_SIZE.medium}
                    overrides={{ BaseButton: { style: { width: '100%' } } }}
                    onClick={() => history.push('/')}
                >
                    Fertig
                </Button>
            </ButtonContainer>
        </Container>
    )
}
